import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

const API_URL = `${getApiBaseUrl()}/api`;

/**
 * Refresh user profile data from the server
 * This is useful to get the latest verification status and other user data
 */
export const refreshUserProfile = async (userId) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return { success: false, message: 'No authentication token found' };
    }

    const response = await axios.get(
      `${API_URL}/users/refresh/${userId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (response.data.success) {
      // Update localStorage with fresh user data
      localStorage.setItem('user', JSON.stringify(response.data.user));
      return { success: true, user: response.data.user };
    }

    return { success: false, message: 'Failed to refresh user data' };
  } catch (error) {
    console.error('Error refreshing user profile:', error);
    return { 
      success: false, 
      message: error.response?.data?.detail || 'Failed to refresh user profile' 
    };
  }
};

/**
 * Get verification status for a user
 */
export const getVerificationStatus = async (userId) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return { success: false, message: 'No authentication token found' };
    }

    const response = await axios.get(
      `${API_URL}/verification/status/${userId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error getting verification status:', error);
    return { 
      success: false, 
      message: error.response?.data?.detail || 'Failed to get verification status' 
    };
  }
};
